import { buildMetricBarSegments } from "./metricSegments";

function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

const SEGMENT_TONES = new Set(["action", "info"]);

// `segments=[{ value, tone, label? }]` is the multi-segment alternative to the
// single `value`. The first segment is the progress value; a segment `label`
// (for example "1 extra") is appended to the accessible name as text.
export default function MetricBar({ value = 0, max = 100, label, segments }) {
  const numericMax = Number(max);
  const resolvedMax = Number.isFinite(numericMax) && numericMax > 0 ? numericMax : 1;
  const segmented = Array.isArray(segments);
  const numericValue = Number(segmented ? segments[0]?.value : value);
  const resolvedValue = Number.isFinite(numericValue)
    ? clamp(numericValue, 0, resolvedMax)
    : 0;
  const percentage = (resolvedValue / resolvedMax) * 100;
  const built = segmented ? buildMetricBarSegments(segments, max) : null;
  const accessibleLabel = segmented
    ? [label, ...segments.map((segment) => segment?.label)].filter(Boolean).join(", ")
    : label;

  return (
    <span
      className={
        segmented
          ? "lz-product-metric-bar lz-product-metric-bar--segmented"
          : "lz-product-metric-bar"
      }
      role="progressbar"
      aria-label={accessibleLabel}
      aria-valuemin="0"
      aria-valuemax={resolvedMax}
      aria-valuenow={resolvedValue}
    >
      {segmented ? (
        (built?.segments || [])
          .filter((segment) => segment.ratio > 0)
          .map((segment, index) => (
            <span
              key={`${segment.tone}-${index}`}
              className="lz-product-metric-bar__segment"
              data-tone={SEGMENT_TONES.has(segment.tone) ? segment.tone : "action"}
              style={{ width: `${segment.ratio * 100}%` }}
            />
          ))
      ) : (
        <span
          className="lz-product-metric-bar__fill"
          style={{ width: `${percentage}%` }}
        />
      )}
    </span>
  );
}
